export default ['450px', '576px', '786px', '1024px', '1200px'];
